import { render, staticRenderFns } from "./MilestoneDetailsPopup.vue?vue&type=template&id=6ed366c0&scoped=true&"
import script from "./MilestoneDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./MilestoneDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneDetailsPopup.vue?vue&type=style&index=0&id=6ed366c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed366c0",
  null
  
)

export default component.exports